export default "__VITE_ASSET__D$25TbOM__"